import { useMutation } from '@tanstack/react-query';

import {
  type Notes_UpsertBehaviourTagInput,
  gqlClient,
  graphql,
  queryClient,
} from '@tyro/api';
import { toast } from '@tyro/core';
import { useTranslation } from '@tyro/i18n';
import { peopleKeys } from '../keys';

const upsertBehaviourTags = graphql(/* GraphQL */ `
  mutation notes_upsertBehaviourTags($input: [Notes_UpsertBehaviourTagInput]) {
    notes_upsertBehaviourTags(input: $input) {
      id
    }
  }
`);

export function useUpsertBehaviourTags() {
  const { t } = useTranslation(['common']);

  return useMutation({
    mutationFn: async (input: Notes_UpsertBehaviourTagInput[]) =>
      gqlClient.request(upsertBehaviourTags, { input }),
    onSuccess: async (_, [note]) => {
      await queryClient.invalidateQueries({
        queryKey: peopleKeys.notes.behaviourTags(),
      });

      toast.success(
        note
          ? t('common:snackbarMessages.updateSuccess')
          : t('common:snackbarMessages.createSuccess'),
      );
    },
    onError: () => {
      toast.error(t('common:snackbarMessages.errorFailed'));
    },
  });
}
